<template>
<svg :width="width" :height="height" viewBox="0 0 19 20" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path d="M0.112137 7.73959L1.32774 0.996964L4.699 1.07188L6.1895 2.94508L8.1453 4.5181L6.8547 7.88939L12.0241 13.0587L15.3953 11.8611L16.7929 13.9098L18.8415 15.3074L18.9165 18.6787L12.1739 19.8014L0.112137 7.73959Z"  fill-opacity="0.3"/>
</svg>

</template>

<script>
export default {
    props: {
        width: { type: [Number, String], default: 19 },
        height: { type: [Number, String], default: 20 },
        color: { type: String, default: "#D3D4DE" }
    }
}
</script>
